<template>
      <md-table>
        <md-table-row>
          <md-table-head>Question</md-table-head>
          <md-table-head>Answer</md-table-head>
        </md-table-row>

        <md-table-row v-for="field in fields" :key=field.id>
          <md-table-cell>{{ field.title }}</md-table-cell>
          <md-table-cell>
            <response-answer v-if="field.answer" :answer="field.answer" />
          </md-table-cell>
        </md-table-row>
      </md-table>
</template>

<script>
import CSApp from '@/components/CSApp'
import ResponseAnswer from '@/components/ResponseAnswer'
import { caseService } from '@/services/caseService'
import { mapGetters } from 'vuex'

export default {
    name: 'CaseDetails',
    components: {
        'cs-app': CSApp,
        ResponseAnswer,
    },
    props: ['claimId'],
    data: () => ({
        fields: [],
    }),
    computed: {
        ...mapGetters([
            'clientCase'
        ])
    },
    created () {
        if (this.clientCase && this.clientCase.id === this.$route.params.id) {
            this.fields = caseService(this.$http).mapCaseFieldsToAnswers(this.clientCase)
        }
        caseService(this.$http).whereId(this.claimId).get().then(response => {
            this.$store.commit('addClientCase', response.data)
            this.fields = caseService(this.$http).mapCaseFieldsToAnswers(this.clientCase)
        })
    }
}
</script>